module.exports = __webpack_public_path__ + "static/define-d0d2dcc4a208422a5b5248f0b9fbe89f.svg";